import type { TutorialCue } from "_shared/tutorials/tutorial-types";

export const ONBOARDING_PROPOSAL_TUTORIAL_ID = "onboarding-proposal";

export const onboardingProposalTutorial: readonly TutorialCue[] = [
  {
    tutorialId: ONBOARDING_PROPOSAL_TUTORIAL_ID,
    cueId: "status",
    contentVersion: 1,
    targetId: "proposal-status",
    title: "Proposal status",
    description: "Use this heading to confirm which proposal you are reviewing.",
    eligible: ({ pathname }) => pathname.startsWith("/proposals/active"),
  },
  {
    tutorialId: ONBOARDING_PROPOSAL_TUTORIAL_ID,
    cueId: "terms",
    contentVersion: 1,
    targetId: "proposal-terms",
    title: "Review the terms",
    description: "Review the proposal details before you save or submit changes.",
    eligible: ({ pathname }) => pathname.startsWith("/proposals/active"),
  },
  {
    tutorialId: ONBOARDING_PROPOSAL_TUTORIAL_ID,
    cueId: "redlines",
    contentVersion: 1,
    targetId: "proposal-redlines",
    title: "Redlines",
    description: "Redlines show changes that need your review.",
    eligible: ({ pathname }) => pathname.startsWith("/proposals/active"),
  },
  {
    tutorialId: ONBOARDING_PROPOSAL_TUTORIAL_ID,
    cueId: "comments",
    contentVersion: 1,
    targetId: "proposal-comments",
    title: "Comments",
    description: "Use comments to ask questions and keep the discussion with the proposal.",
    eligible: ({ pathname }) => pathname.startsWith("/proposals/active"),
  },
  {
    tutorialId: ONBOARDING_PROPOSAL_TUTORIAL_ID,
    cueId: "timeline",
    contentVersion: 1,
    targetId: "proposal-timeline",
    title: "Timeline",
    description: "The timeline records visible changes and review activity.",
    eligible: ({ pathname }) => pathname.startsWith("/proposals/active"),
  },
  {
    tutorialId: ONBOARDING_PROPOSAL_TUTORIAL_ID,
    cueId: "submit-changes",
    contentVersion: 1,
    targetId: "proposal-submit-changes",
    title: "Submit Changes",
    description: "Submit your changes to AttorneyHub for review.",
    eligible: ({ pathname }) => pathname.startsWith("/proposals/active"),
  },
  {
    tutorialId: ONBOARDING_PROPOSAL_TUTORIAL_ID,
    cueId: "approval",
    contentVersion: 1,
    targetId: "proposal-approval",
    title: "Approve the proposal",
    description: "Approve after you resolve the redlines and finish your review.",
    eligible: ({ pathname }) => pathname.startsWith("/proposals/active"),
  },
  {
    tutorialId: ONBOARDING_PROPOSAL_TUTORIAL_ID,
    cueId: "hire",
    contentVersion: 1,
    targetId: "proposal-hire",
    title: "Hire AttorneyHub",
    description: "Hire AttorneyHub after both sides approve the final proposal.",
    eligible: ({ pathname }) => pathname.startsWith("/proposals/active"),
  },
];

export const tutorialRegistry: Record<string, readonly TutorialCue[]> = {
  [ONBOARDING_PROPOSAL_TUTORIAL_ID]: onboardingProposalTutorial,
};

export function getTutorialCues(tutorialId?: string): readonly TutorialCue[] {
  if (tutorialId) return tutorialRegistry[tutorialId] ?? [];
  return Object.values(tutorialRegistry).flat();
}
